import store from "@/store/index";
import router from "@/router";
import { refresh } from "@/api/auth";

let isTokenRefreshing = false;
let refreshSubscribers = [];

// 리프레시 후, 대기 중인 요청을 재시도하기 위한 콜백 실행
const onTokenRefreshed = (ndbTkn) => {
	refreshSubscribers.forEach((callback) => callback(ndbTkn));
	refreshSubscribers = [];
};

// 토큰 갱신이 완료되면 재시도할 요청을 등록
const addRefreshSubscriber = (callback) => {
	refreshSubscribers.push(callback);
};

export function setInterseptors(instance) {
	instance.interceptors.request.use(
		(config) => {
			const accessToken = store.getters["userStore/getAccessToken"];
			config.headers.Authorization = `Bearer ${accessToken}`;
			return config;
		},
		function (error) {
			return Promise.reject(error);
		},
	);

	instance.interceptors.response.use(
		(response) => {
			return response;
		},
		async (error) => {
			const {
				config,
				response: { status }
			} = error;

			const errorCode = error.response.data.code;
			if (status === 401 && errorCode !== 'U002') {

				const originalRequest = config;

				if (errorCode === "A003") {
					if (!isTokenRefreshing) {
						isTokenRefreshing = true;
						try {

							const originalToken = store.getters["userStore/getAccessToken"];
							const refreshResponse = await refresh(originalToken);
							store.dispatch("userStore/REFRESH_USER", refreshResponse.data.data);
						} catch (refreshError) {
							console.log(refreshError)
							onTokenRefreshed(null);
							alert('다시 로그인 해주세요.');
							store.dispatch("userStore/LOGOUT");
							router.push("/login");
							return Promise.reject(refreshError);
						} finally {
							isTokenRefreshing = false;
						}
					}

					return new Promise((resolve) => {
						addRefreshSubscriber((accessToken) => {
							originalRequest.headers.Authorization = `Bearer ${accessToken}`;
							resolve(instance(originalRequest)); // 인스턴스를 사용하여 기존 요청 재시도
						});
						onTokenRefreshed();
					});
				} else if (errorCode === "A004") {
					alert("로그인이 필요합니다.");
				}
				router.push("/login");
			} else if (status === 404) {
			}
			return Promise.reject(error);
		}
	);
	return instance;
}
